<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btn btn-outline-success" type="button" title="Nuevo" (click)="onAdd()"><i class="fa fa-file-o"></i> Nuevo </button>
        <button *ngIf="!visibilitySpinner" type="button" [disabled]="!resultTipoDocumentacionEx?.ResultList || resultTipoDocumentacionEx?.ResultList?.length === 0" class="btn btn-outline-success" title="Exportar" (click)="onExportExcel()"><i class="fa fa-file-excel-o"></i> Exportar </button>
        <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Exportando
        </button>
    </form>
</nav>

<form [formGroup]="form" class="container-fluid" autocomplete="off">
    <div class="animated fadeIn">
        <h4>Buscador de Tipos de Documentación Exportación</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed"
                       [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">

                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpTipo">Tipo de Solicitud Ex</label>
                                    <ng-select [items]="listTipoSolicitudEx"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdTipoSolicitudEx"
                                               loadingText="Cargando..."
                                               [readonly]="!listTipoSolicitudEx || listTipoSolicitudEx.length === 0"
                                               [loading]="!listTipoSolicitudEx || listTipoSolicitudEx.length === 0"
                                               notFoundText="Tipo no encontrado"
                                               placeholder="-- Seleccione un Tipo --"
                                               clearAllText="Eliminar selección">

                                        <ng-template ng-label-tmp let-item="item">
                                            <img src="/assets/images/TipoSolicitudEx/{{item.Id}}.png" style="width:24px;vertical-align:middle" />
                                            <span style="vertical-align:middle; margin-left: .5em">{{item.Descripcion}}</span>
                                        </ng-template>
                                        <ng-template ng-option-tmp let-item="item" let-index="index">
                                            <img src="/assets/images/TipoSolicitudEx/{{item.Id}}.png" style="width:24px;vertical-align:middle" />
                                            <span style="vertical-align:middle; margin-left: .5em">{{item.Descripcion}}</span>
                                        </ng-template>
                                    </ng-select>
                                </div>                                

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpCodigo">Descripción</label>
                                    <input formControlName="Descripcion" name="Descripcion" maxlength="150" title="" class="form-control" id="inpDescripcion" type="text" value="">
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpCodigo">Descripción Traces</label>
                                    <input formControlName="DescripcionTraces" name="DescripcionTraces" maxlength="150" title="" class="form-control" id="inpDescripcionTraces" type="text" value="">
                                </div>

                            </div>

                            <div class="row">

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpRequerirTexto">Requiere Texto</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="RequerirTexto"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpRequerirFecha">Requiere Fecha</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="RequerirFecha"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpRequerirPais">Requiere País</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="RequerirPais"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpAttachedTraces">Adjuntar Traces</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="AttachedTraces"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpActivo">Activo</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="Activo"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit" title="Realiza una búsqueda" (click)="onSearchButton()"><i class="fa fa-search"></i> Buscar</button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros" (click)="onCleanButton()"><i class="fa fa-eraser"></i> Limpiar</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>


        <!--DATAGRID-->

        <div *ngIf="searchingButton" class="row">
            <div class="col-md-12">
                <div class="card card-accent-success">
                    <div class="card-header-buscador">
                        <i class="fa fa-align-justify"></i> Listado de Tipos de Documentación Exportación
                    </div>

                    <div class="card-body-grid">

                        <p-table #tableSearch autoLayout="true" [value]="resultTipoDocumentacionEx?.ResultList" [lazy]="true" (onLazyLoad)="onSearchLazy($event)"
                                 [paginator]="true"
                                 [columns]="cols" sortField="Descripcion" [rows]="resultTipoDocumentacionEx?.PageSize" [totalRecords]="resultTipoDocumentacionEx?.TotalCount"
                                 [loading]="loading"
                                 styleClass="table table-responsive-sm  table-striped table-sm"
                                 [ngClass]="displayGridHidden(resultTipoDocumentacionEx?.ResultList)">

                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display':col?.display}" [pSortableColumn]="col?.field">
                                        {{col?.header}}
                                        <p-sortIcon *ngIf="col?.field !== 'Link'" [field]="col?.field"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                                <tr>
                                    <td *ngFor="let col of columns" [ngStyle]="{'display': col?.display}">
                                        <span *ngIf="col.field!=='Link' && col.field!=='HabilitadaImportacion'
                                          && col.field!=='RequerirTexto' && col.field!=='RequerirFecha' && col.field!=='RequerirPais' && col.field!=='AttachedTraces' && col.field!=='Activo'">
                                            {{rowData[col.field]}}
                                        </span>
                                        <span *ngIf="col.field==='RequerirTexto' || col.field==='RequerirFecha' || col.field==='RequerirPais'|| col.field==='AttachedTraces' || col.field==='Activo'">
                                            {{rowData[col.field] | siNo}}
                                        </span>
                                        <div *ngIf="col.field==='Link'" class="btn-group">
                                            <button (click)="onEdit(rowData)" type="button" title="Editar"
                                                    class="btn btn-sm btn-warning">
                                                <span class="fa fa-edit"></span>

                                            </button>
                                            <button (click)="onDelete(rowData)" type="button" title="Eliminar"
                                                    class="btn btn-sm btn-danger">
                                                <span class="fa fa-remove"></span>

                                            </button>
                                        </div>
                                    </td>
                                </tr>

                            </ng-template>

                        </p-table>
                        <div *ngIf="tableSearch?.totalRecords === 1" class="p-2">Se ha encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registro</div>
                        <div *ngIf="tableSearch?.totalRecords > 1" class="p-2">Se han encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registros</div>
                        <div class="empty-grid" *ngIf="tableSearch?.totalRecords === 0">No se ha encontrado ningún registro</div>
                    </div>

                </div>
            </div>
        </div>
    </div>

</form>
